import React from 'react';

import { ModalProps } from 'antd/lib/modal';

import * as Styled from './Modal.style';

export type Props = ModalProps & { children: React.ReactNode };

export const Modal = (props: Props): JSX.Element => <Styled.Modal centered {...props} />;
